export default {
	fr: {
		messages: {
			required: (field) => `Le champ ${field.toLowerCase()} est obligatoire.`,
			email: (field) => `Le champ ${field.toLowerCase()} n'est pas valide.`,
			authorize: (field) => `Vous devez autoriser le champ ${field.toLowerCase()}.`
		}
	}
}


// WEBPACK FOOTER //
// ./src/i18n/vee-validate/vee-validate_fr.js